export default __webpack_public_path__ + "a85e1a91be6d9b17d84e8a93e6053db8.ttf";